import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  fullWidthLabel: {
    id: 'fabric.editor.breakoutFullWidthLabel',
    defaultMessage: 'Full-width',
    description: 'Resize current element to full-width mode'
  },
  wideWidthLabel: {
    id: 'fabric.editor.breakoutWideWidthLabel',
    defaultMessage: 'Wide',
    description: 'Resize current element to wide mode'
  }
});